{
  "runId": "collection-295fb51f6807831f37a78c0a",
  "completedAt": "2026-09-23T23:57:05.491Z",
  "questionCount": 62,
  "targets": [
    {
      "id": "arya-repeat",
      "label": "Gab Arya",
      "developer": "Gab AI",
      "logo": "/brand-assets/gab-ai-mark-black.svg",
      "point": {
        "economy": 1.13,
        "authority": 3.49
      }
    },
    {
      "id": "gpt-6-astra",
      "label": "GPT-6 Astra",
      "developer": "OpenAI",
      "logo": "https://cdn.gab.ai/models/logos/gpt-6-astra-f445f49e5236.png",
      "point": {
        "economy": -6.38,
        "authority": -6.1
      }
    },
    {
      "id": "deepseek-v4-pro-0813",
      "label": "DeepSeek V4 Pro",
      "developer": "DeepSeek",
      "logo": "https://cdn.gab.ai/models/logos/793d5c07-5ac1-4d1b-8517-ec1239d65ab2.png",
      "point": {
        "economy": -5.75,
        "authority": -5.18
      }
    },
    {
      "id": "grok-4-7",
      "label": "Grok 4.7",
      "developer": "xAI",
      "logo": "https://cdn.gab.ai/brand-assets/import-providers/grok.svg",
      "point": {
        "economy": -2.75,
        "authority": -6.05
      }
    },
    {
      "id": "gpt-6-sol",
      "label": "GPT-6 Sol",
      "developer": "OpenAI",
      "logo": "https://cdn.gab.ai/models/logos/gpt-6-sol-66037b5d678a.png",
      "point": {
        "economy": -5.13,
        "authority": -5.44
      }
    },
    {
      "id": "muse-spark-1-3",
      "label": "Muse Spark 1.3",
      "developer": "Meta",
      "logo": "https://cdn.gab.ai/models/logos/25c2ec94-9031-485b-81a9-9853d2935668.png",
      "point": {
        "economy": -4.63,
        "authority": -5.85
      }
    },
    {
      "id": "gemini-3-1-pro",
      "label": "Gemini 3.1 Pro Preview",
      "developer": "Google",
      "logo": "https://cdn.gab.ai/models/logos/3b3c6aa4-800a-4cc7-88d2-c77ad30aefca.png",
      "point": {
        "economy": -5.63,
        "authority": -6.41
      }
    },
    {
      "id": "deepseek-v4-1-flash",
      "label": "DeepSeek V4.1 Flash",
      "developer": "DeepSeek",
      "logo": "https://cdn.gab.ai/models/logos/669a8da5-ab82-4f97-8f90-fc7c4cabb1a5.png",
      "point": {
        "economy": -6.25,
        "authority": -6.31
      }
    },
    {
      "id": "qwen-3-8-max-prime",
      "label": "Qwen 3.8 Max Prime",
      "developer": "Alibaba",
      "logo": "https://cdn.gab.ai/models/logos/55d3ae69-f642-4d72-9c45-2ed2c77f3a9c.png",
      "point": {
        "economy": -5.75,
        "authority": -6.15
      }
    },
    {
      "id": "kimi-k3",
      "label": "Kimi K3",
      "developer": "Moonshot AI",
      "logo": "https://cdn.gab.ai/models/logos/9ed44a7f-159c-441f-b7ab-4232af1358dd.png",
      "point": {
        "economy": -6,
        "authority": -6.1
      }
    },
    {
      "id": "glm-5-3",
      "label": "GLM 5.3",
      "developer": "Z.ai",
      "logo": "https://cdn.gab.ai/models/logos/ee6b1944-d891-472d-b900-03d818eb4040.png",
      "point": {
        "economy": -4.63,
        "authority": -5.28
      }
    },
    {
      "id": "mistral-medium-3-5",
      "label": "Mistral Medium 3.5",
      "developer": "Mistral AI",
      "logo": "https://www.google.com/s2/favicons?domain=mistral.ai&sz=64",
      "point": {
        "economy": -5.63,
        "authority": -5.44
      }
    },
    {
      "id": "llama-4-maverick",
      "label": "Llama 4 Maverick",
      "developer": "Meta",
      "logo": "https://cdn.gab.ai/models/logos/25c2ec94-9031-485b-81a9-9853d2935668.png",
      "point": {
        "economy": -3.63,
        "authority": -3.59
      }
    },
    {
      "id": "gemma-4-31b",
      "label": "Gemma 4 31B",
      "developer": "Google",
      "logo": "https://cdn.gab.ai/models/logos/b2fff35c-9759-41ab-af17-7ca958ac3fe3.png",
      "point": {
        "economy": -4.88,
        "authority": -5.08
      }
    },
    {
      "id": "nova-2-lite",
      "label": "Nova 2 Lite",
      "developer": "Amazon",
      "logo": "https://www.google.com/s2/favicons?domain=amazon.com&sz=64",
      "point": {
        "economy": -3.75,
        "authority": -5.18
      }
    },
    {
      "id": "nemotron-3-5-lightning",
      "label": "Nemotron 3.5 Lightning",
      "developer": "NVIDIA",
      "logo": "https://www.google.com/s2/favicons?domain=nvidia.com&sz=64",
      "point": {
        "economy": -4.63,
        "authority": -5.08
      }
    },
    {
      "id": "minimax-m3",
      "label": "MiniMax M3",
      "developer": "MiniMax",
      "logo": "https://cdn.gab.ai/models/logos/e2273832-cd91-40f8-be5a-60d35ac7c1a3.png",
      "point": {
        "economy": -4.63,
        "authority": -4.36
      }
    }
  ]
}
